import React, { useContext } from "react";
import { DataContext } from "../../../context/context";

import { Styled } from "./ResponseTimeItem.styled";

const ResponseTimeItem = ({
  color,
  header,
  description,
  value,
  selectPeriod,
}) => {
  const { state } = useContext(DataContext);

  return (
    <Styled.MainBox $color={color === "yellow"}>
      <Styled.InsideBox>
        <Styled.HeaderBox $color={color === "yellow"}>
          {header}
        </Styled.HeaderBox>
        <Styled.GroupBox>
          <Styled.GroupItemLeft>
            <Styled.DescriptionBox $color={color === "yellow"}>
              {description}
            </Styled.DescriptionBox>
            <Styled.ItemBox>
              <Styled.ItemBoxIcon1>{selectPeriod}</Styled.ItemBoxIcon1>
              <Styled.ItemValueIconMark>⌀</Styled.ItemValueIconMark>
              <Styled.ItemValue $color={color === "yellow"}>
                {value}
              </Styled.ItemValue>
            </Styled.ItemBox>
          </Styled.GroupItemLeft>
          <Styled.GroupItemRight>
            <Styled.ItemBoxIcon2
              color={color === "yellow" ? "#EFF2F7" : "#ccc"}
            ></Styled.ItemBoxIcon2>
          </Styled.GroupItemRight>
        </Styled.GroupBox>
      </Styled.InsideBox>
    </Styled.MainBox>
  );
};

export default ResponseTimeItem;
